import { Component, OnDestroy } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-basecomponent',
  template: '',
  providers: []
})
export class BaseComponent implements OnDestroy {

  subscriptions: Subscription[] = new Array<Subscription>();
  public loading$ = new BehaviorSubject<boolean>(true);
  private routeSelectedParams = {};
  constructor() { }

  public addToSelectedParams(key: string, value: any) {
    this.routeSelectedParams[key] = value;
  }
  public removeFromSelectedParams(key) {
    this.routeSelectedParams[key] = undefined;
  }

  public clearAllSelectedParams() {
    this.routeSelectedParams = {};
  }
  public get SelectedParams() {
    return this.routeSelectedParams;
  }


  ngOnDestroy() {
    this.subscriptions.forEach(elem => {
      elem.unsubscribe();
    });
  }
}


